/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_SubtitleInputs */

const he_contact_success_subtitle = /** @type {(inputs: Contact_Success_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תודה שפנית אלינו — נחזור אליך בהקדם.`)
};

const en_contact_success_subtitle = /** @type {(inputs: Contact_Success_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for reaching out — we'll get back to you soon.`)
};

/**
* | output |
* | --- |
* | "Thanks for reaching out — we'll get back to you soon." |
*
* @param {Contact_Success_SubtitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_subtitle = /** @type {((inputs?: Contact_Success_SubtitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_SubtitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_subtitle(inputs)
	return en_contact_success_subtitle(inputs)
});